import { React } from "react";
import VerificationComponent from "../../components/Verification/Verfication";

function Verification() {
    return <VerificationComponent />;
}

export default Verification;
